import { render } from "./new - 副本.vue?vue&type=template&id=ded6d5c4&scoped=true"
import script from "./new - 副本.vue?vue&type=script&lang=js"
export * from "./new - 副本.vue?vue&type=script&lang=js"

import "./new - 副本.vue?vue&type=style&index=0&id=ded6d5c4&lang=less&scoped=true"

import exportComponent from "D:\\liang_front_end\\agent-yuyooke\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ded6d5c4"]])

export default __exports__